import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IAddEmployeeSchema, IEmployeeState } from './types';

const initialState: IEmployeeState = {
  employees: {},
  addEmployee: {},
  updateEmployeeStatus: {},
  updateEmployee: {},
  employeeDetails: {},
  employeeActivity: {},
  searchEmployeesInterns: {},
};

const slice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    getEmployees(state) {
      state.employees.status = RequestStatus.RUNNING;
    },
    getEmployeesSuccess(state, action: PayloadAction<IEmployeeState['employees']['data']>) {
      state.employees.status = RequestStatus.SUCCESS;
      state.employees.data = action.payload;
    },
    getEmployeesFailed(state, action: PayloadAction<IRequestFailed>) {
      state.employees.status = RequestStatus.ERROR;
      state.employees.error = action.payload;
    },

    // ===========================
    addEmployee(state, action: PayloadAction<IAddEmployeeSchema>) {
      state.addEmployee.status = RequestStatus.RUNNING;
    },
    addEmployeeSuccess(state, action) {
      state.addEmployee.status = RequestStatus.SUCCESS;
      state.addEmployee.data = action.payload;
    },
    addEmployeeFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addEmployee.status = RequestStatus.ERROR;
      state.addEmployee.error = action.payload;
    },
    //
    updateEmployeeStatus(state, action: PayloadAction<any>) {
      state.updateEmployeeStatus.status = RequestStatus.RUNNING;
    },
    updateEmployeeStatusSuccess(state, action: PayloadAction<IAddEmployeeSchema>) {
      state.updateEmployeeStatus.status = RequestStatus.SUCCESS;
      state.updateEmployeeStatus.data = action.payload;
    },
    updateEmployeeStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateEmployeeStatus.status = RequestStatus.ERROR;
      state.updateEmployeeStatus.error = action.payload;
    },
    updateEmployee(state, action: PayloadAction<any>) {
      state.updateEmployee.status = RequestStatus.RUNNING;
    },
    updateEmployeeSuccess(state, action: PayloadAction<IAddEmployeeSchema>) {
      state.updateEmployee.status = RequestStatus.SUCCESS;
      state.updateEmployee.data = action.payload;
    },
    updateEmployeeFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateEmployee.status = RequestStatus.ERROR;
      state.updateEmployee.error = action.payload;
    },
    //
    getEmployeeDetails(state, action: PayloadAction<IAddEmployeeSchema>) {
      state.employeeDetails.status = RequestStatus.RUNNING;
    },
    getEmployeeDetailsSuccess(
      state,
      action: PayloadAction<IEmployeeState['employeeDetails']['data']>
    ) {
      state.employeeDetails.status = RequestStatus.SUCCESS;
      state.employeeDetails.data = action.payload;
    },
    getEmployeeDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.employeeDetails.status = RequestStatus.ERROR;
      state.employeeDetails.error = action.payload;
    },
    //
    getEmployeeActivityById(state) {
      state.employeeActivity.status = RequestStatus.RUNNING;
    },
    getEmployeeActivityByIdSuccess(
      state,
      action: PayloadAction<IEmployeeState['employeeActivity']['data']>
    ) {
      state.employeeActivity.status = RequestStatus.SUCCESS;
      state.employeeActivity.data = action.payload;
    },
    getEmployeeActivityByIdFailed(state, action: PayloadAction<IRequestFailed>) {
      state.employeeActivity.status = RequestStatus.ERROR;
      state.employeeActivity.error = action.payload;
    },
    //
    getEmployeesInternsSearch(state, action: PayloadAction<string | undefined>) {
      state.searchEmployeesInterns.status = RequestStatus.RUNNING;
    },
    getEmployeesInternsSearchSuccess(
      state,
      action: PayloadAction<IEmployeeState['employees']['data']>
    ) {
      state.searchEmployeesInterns.status = RequestStatus.SUCCESS;
      state.searchEmployeesInterns.data = action.payload;
    },
    getEmployeesInternsSearchFailed(state, action: PayloadAction<IRequestFailed>) {
      state.searchEmployeesInterns.status = RequestStatus.ERROR;
      state.searchEmployeesInterns.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  updateEmployeeStatus,
  updateEmployeeStatusSuccess,
  updateEmployeeStatusFailed,
  getEmployees,
  getEmployeesSuccess,
  getEmployeesFailed,
  addEmployee,
  addEmployeeSuccess,
  addEmployeeFailed,
  updateEmployee,
  updateEmployeeSuccess,
  updateEmployeeFailed,
  getEmployeeDetails,
  getEmployeeDetailsFailed,
  getEmployeeDetailsSuccess,
  getEmployeeActivityById,
  getEmployeeActivityByIdFailed,
  getEmployeeActivityByIdSuccess,
  getEmployeesInternsSearch,
  getEmployeesInternsSearchFailed,
  getEmployeesInternsSearchSuccess,
} = slice.actions;
